"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _MultipleChoiceFilter = _interopRequireDefault(require("../MultipleChoiceFilter"));
var _Button = _interopRequireDefault(require("../Button"));
var _excluded = ["presets", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * returns selected preset.
 * The preset is set to be selected,
 * if all the available items by that preset categoty is selected
 * and nothing is selected from different categories
 * @param {*} items
 * @param {*} presets
 */
var findSelectedCategory = function findSelectedCategory(items, presets) {
  var activeItems = items.filter(function (item) {
    return !item.disabled;
  });
  var selectedItems = activeItems.filter(function (item) {
    return item.selected;
  });
  var selectedCategories = presets.reduce(function (res, _ref) {
    var id = _ref.id,
      field = _ref.field;
    var isActive = !(0, _isEmpty2["default"])(selectedItems) && selectedItems.every(function (item) {
      return item[field] === id;
    }) && selectedItems.length === activeItems.filter(function (item) {
      return item[field] === id;
    }).length;
    if (isActive) {
      res.push(id);
    }
    return res;
  }, []);
  return selectedCategories.length === 1 ? selectedCategories[0] : null;
};
var FilterWithPreset = function FilterWithPreset(_ref2) {
  var presets = _ref2.presets,
    className = _ref2.className,
    filterProps = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var items = filterProps.items,
    isMobile = filterProps.isMobile,
    onChange = filterProps.onChange;
  (0, _react.useEffect)(function () {
    return setActive(findSelectedCategory(items, presets));
  }, [items, presets]);
  var handleClick = function handleClick(_ref3) {
    var id = _ref3.id,
      field = _ref3.field;
    if (active === id) {
      var newItems = items.map(function (i) {
        return _objectSpread(_objectSpread({}, i), {}, {
          selected: false
        });
      });
      setActive(null);
      onChange(newItems);
    } else {
      var _newItems = items.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          selected: item[field] === id && !item.disabled
        });
      });
      setActive(id);
      onChange(_newItems);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(StyledFilterWithPreset, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledPresetContainer, {
    isMobile: isMobile
  }, presets.map(function (_ref4) {
    var id = _ref4.id,
      label = _ref4.label,
      field = _ref4.field;
    return /*#__PURE__*/_react["default"].createElement(StyledPresetButton, {
      isMobile: isMobile,
      key: id,
      disabled: items.filter(function (item) {
        return item[field] === id;
      }).every(function (item) {
        return item.disabled;
      }),
      isActive: active === id,
      onClick: function onClick() {
        return handleClick({
          id: id,
          field: field
        });
      }
    }, label);
  })), /*#__PURE__*/_react["default"].createElement(_MultipleChoiceFilter["default"], filterProps));
};
var StyledPresetButton = (0, _styledComponents["default"])(_Button["default"]).attrs({
  functional: true
}).withConfig({
  displayName: "FilterWithPreset__StyledPresetButton",
  componentId: "sc-1j8xv8l-0"
})(["display:flex;justify-content:center;align-items:center;padding:0 8px;flex-shrink:0;background-color:var(--background);border-radius:var(--border-radius);color:var(--black);font-size:14px;font-style:normal;font-weight:400;line-height:16px;", " ", " ", ""], function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile && (0, _styledComponents.css)(["flex-grow:1;padding:0;font-size:16px;line-height:20px;"]);
}, function (_ref6) {
  var isActive = _ref6.isActive;
  return isActive && (0, _styledComponents.css)(["background-color:var(--secondary);color:var(--white);"]);
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled && (0, _styledComponents.css)(["opacity:var(--disabled-opacity);"]);
});
var StyledPresetContainer = _styledComponents["default"].div.withConfig({
  displayName: "FilterWithPreset__StyledPresetContainer",
  componentId: "sc-1j8xv8l-1"
})(["display:flex;gap:4px;height:32px;margin-bottom:10px;", ""], function (_ref8) {
  var isMobile = _ref8.isMobile;
  return isMobile && (0, _styledComponents.css)(["height:44px;margin-left:10px;margin-right:10px;"]);
});
FilterWithPreset.propTypes = {
  className: _propTypes["default"].string,
  presets: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    field: _propTypes["default"].string.isRequired
  })).isRequired,
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  onChange: _propTypes["default"].func.isRequired,
  visibleItems: _propTypes["default"].number,
  expandLabel: _propTypes["default"].string,
  LabelComponent: _propTypes["default"].func,
  isMobile: _propTypes["default"].bool,
  currencyCode: _propTypes["default"].string
};
FilterWithPreset.defaultProps = {
  className: '',
  visibleItems: Infinity,
  expandLabel: 'Показать все',
  LabelComponent: undefined,
  isMobile: false
};
var StyledFilterWithPreset = _styledComponents["default"].div.withConfig({
  displayName: "FilterWithPreset__StyledFilterWithPreset",
  componentId: "sc-1j8xv8l-2"
})([""]);
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(FilterWithPreset);